
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchZones } from "slices/zoneSlice";
import { zoneSelector } from "slices/zoneSlice";

import Api from "services/api"
import AddZone from "components/zone/AddZone";
import toast from "react-hot-toast";
import ConfirmationModal from "components/common/ConfirmationMessage";
import { ListLayout } from "components/common/ListLayout";
import { SortButtons } from "components/common/SortButtons";
import { CustomSwitch } from "components/common/Switch";
import { changeStatus } from "slices/zoneSlice";
import { removeMultipleZones } from "slices/zoneSlice";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { convertTimeToUTC } from "helpers/convertTimeToUTC";
import { usePermissions } from "layouts/Admin";

const apiService = new Api();

function ZoneList() {
  const dispatch = useDispatch()
  const { checkPermission } = usePermissions();
  const { zones, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(zoneSelector);
  const [addForm, setAddForm] = React.useState({
    show: false,
    item: {}

  });
  const refAddutton = React.useRef(null);

  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState([10])
  const [currentPage, setCurrentPage] = React.useState(1);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [sortConfig, setSortConfig] = React.useState({
    sortBy: 'name',
    sortDirection: 'asc',
  });



  React.useEffect(() => {
    dispatch(fetchZones())
  }, [])

  const handleAddZonePopUp = (item) => {
    setAddForm({
      show: true,
      item,
    });
  };

  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message, {
        className: "successToast",
      })
      setSelectedItems([]);
      setSelectAll(false)
      dispatch(fetchZones())
      hideConfirmDialog()
    }
    else {
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const showConfirmDialog = () => {
    setDeleteModal(true);
    return
  };
  const hideConfirmDialog = () => {
    setDeleteModal(false);
  }
  const handleRemoveItems = () => {
    dispatch(removeMultipleZones({ ids: selectedItems }, submitCallback))
  }
  const handleChange = (e) => {
    // handle form change
    const id = e.target.dataset.value
    setSelectedItems(
      selectedItems.includes(id) ?
        selectedItems.filter((item) => item != id) :
        [...selectedItems, id]
    )
  };
  const handleToggleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([])
      setSelectAll(false)
      return
    }
    setSelectAll(true)
    setSelectedItems(zones?.map((zone) => zone.id.toString()))


  }

  const handlePageChange = React.useCallback((page) => {
    setCurrentPage(page);
    dispatch(fetchZones(page));
  }, [])

  const handleClose = () => {
    refAddutton.current.click(); setAddForm({ show: false })
  };

  const handleSelect = (value) => {
    setSelectedValue(value)

  }


  //#region TABLE HEAD 

  const renderTableHeader = React.useCallback(() => {


    const callBack = (dir, sortBy) => {

      setSortConfig({ sortBy, sortDirection: dir })
      dispatch(fetchZones(currentPage, { sortBy: sortBy, sortDirection: dir, search: searchTerm }))
    }

    return (
      <tr>
        <th className="col-2">
          <div className="row_check">
            <span>#</span>
            {checkPermission('Delete Cities') &&
              <label className="custom-checkbox checkbox"><input type="checkbox" name="select-all" checked={selectAll} onChange={handleToggleSelectAll} /><span className="checkmark"></span></label>
            }
          </div>
        </th>
        <th className="col-8">
          <TableHeaderItem
            title="Zone Name"
            sortBy="name"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        {/* <th className="col-3">
          <TableHeaderItem
            title="Creation Date"
            sortBy="created_at"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        {checkPermission('Status Cities') &&
          <th >Status</th>
        } */}
        {checkPermission('Edit Cities') &&
          <th className="col-2" >Actions</th>
        }
      </tr>
    )
  }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems]);

  //#endregion


  //#region TABLE BODY

  const renderTableContent = React.useCallback(() => {
    return (
      zones?.map((zone, index) => (
        <ZoneItem zone={zone} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddZonePopUp} current_page={current_page} pageLength={pageLength} checkPermission={checkPermission} />
      ))
    )
  }, [zones, selectedItems]);

  //#endregion


  return (
    <ListLayout
      heading="Zone"
      time={true}
      title=""
      buttonTitle="Add Zone"
      renderTableHeader={renderTableHeader}
      renderTableContent={renderTableContent}
      addButtonDisabled={!checkPermission('Create Cities')}
      totalPages={totalPages}
      fetchList={fetchZones}
      selectedItems={selectedItems}
      handleRemoveItems={handleRemoveItems}
      renderAddForm={(callback) => <AddZone item={addForm.item} show={addForm.show} onClose={handleClose} callback={callback} statusPerm={checkPermission('Status Cities')} />}
      refAddutton={refAddutton}
      addForm={addForm}
      showConfirmDialog={showConfirmDialog}
      handleAddPopUp={handleAddZonePopUp}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      loader={loader}
      searchPlaceholder="Search Zone ..."
      noOfItems={total}

    >

      {deleteModal && <ConfirmationModal onClose={hideConfirmDialog} isOpen={deleteModal} onConfirm={handleRemoveItems} />}
    </ListLayout>
  )

}


const ZoneItem = ({
  zone, index, selectedItems, handleChange, handleAddPopUp, current_page, pageLength, checkPermission
}) => {
  const dispatch = useDispatch();
  const [status, setStatus] = React.useState(zone?.status == "active" ? 1 : 0 || 0);

  const handleStatusChange = (id, s) => {
    setStatus(s ? 1 : 0)
    dispatch(changeStatus(id, { status: s ? 1 : 0 }));

  }

  React.useEffect(() => {
    setStatus(zone?.status == "active" ? 1 : 0 || 0)

  }, [zone])

  const getBackgroundStyle = (status) => {
    return status === 0 ? { background: '#f4f4f4' } : {};
  };
  const serial = useMemo(() => {
    return index + 1 + (current_page - 1) * pageLength;
  }, [current_page, pageLength]);
  return (
    <tr>
      <td style={getBackgroundStyle("")}>
        <div className="row_check">
          <span>{serial}</span>
          {checkPermission('Delete Cities') &&
            <label className="custom-checkbox checkbox">
              <input type="checkbox" name="select-all" data-value={zone.id} checked={selectedItems.includes(zone.id.toString())} onChange={handleChange} />
              <span className="checkmark"></span>
            </label>
          }
        </div>
      </td>
      <td style={getBackgroundStyle("")}>
        {zone.name}
      </td>
      {/* <td style={getBackgroundStyle("")}>
        {convertTimeToUTC(zone.created_at)}
      </td> */}
      {/* {checkPermission('Status Cities') &&
        <td style={getBackgroundStyle("")}>
          <CustomSwitch handleChange={(status) => handleStatusChange(zone?.id, status)} checked={status == 1 ? true : false} />
        </td>
      } */}
      {checkPermission('Edit Cities') &&
        <td style={getBackgroundStyle("")}>
          <button className="table_edit" data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={() => handleAddPopUp({ ...zone, status })}>Edit</button>
        </td>
      }
    </tr>
  )
}


export default ZoneList;
